import React, {
  useContext
} from "react";

import { 
  withRouter
} from "react-router-dom";

import PropTypes from 'prop-types';

import {
  SalesContext
} from "./../../../Context/SalesContext";

import CallMeBackBtn from '../../Common/CallMeBackBtn/CallMeBackBtn';

import {
  Text,
  Subtitle,
  HorizontalLine,
  WhiteTile,
  GreenButton,
} from "./../../../StyledComponents";

import { 
  ProtectionLock
} from "./../Svg";

import {
  SummaryRow
} from "./Components";

import "./OrderSummaryMobile.css";

const OrderSummaryMobile = (props) => {
  const context = useContext(SalesContext);

  const [expanded, setIsExpanded] = React.useState(false);

  const onDiscount = context.selectedPackage?.onDiscount;

  const submitClickHandler = () => {
    if (!props.submitRoute) {
      return;
    }

    if (props.nextCallBack) {
      return props.nextCallBack();
    }

    window.scrollTo(0, 0);
    props.history && props.history.push(props.submitRoute);

  };

  const expansionClickHandler = () => {
    setIsExpanded(!expanded);
  };

  let xDown = null;
  let yDown = null;

  const touchStartHandler = (event) => {
    const firstTouch = event.touches[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  };

  const onTouchMoveHandler = (event) => {
    if (!xDown || !yDown) {
      return;
    }

    const xDiff = xDown - event.touches[0].clientX;
    const yDiff = yDown - event.touches[0].clientY;

    if (Math.abs(xDiff) < Math.abs(yDiff)) {
      if (yDiff > 0) {
        setIsExpanded(true);
      } else {
        setIsExpanded(false);
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;
  };

  const selectedAdditionalServiceKeys = Object.keys(
    context.selectedAdditionalServices
  ).filter((e) => context.selectedAdditionalServices[e] === true);

  let selectedAdditionalServices = [];
  let additionalServicesVAS = [];

  if (context.additionalServices && context.additionalServices.serviceCategories) {
    context.additionalServices.serviceCategories.map((service) => {
      if (!service.offerId)
        additionalServicesVAS.push(service);
    })
  }

  if (additionalServicesVAS) {
    selectedAdditionalServices = additionalServicesVAS.filter((e) =>
      selectedAdditionalServiceKeys.find((key) => key === e.vasCategory)
    );
  }

  let monthlyTotal = 0;
  let onceOffTotal = 0;
  const totalDiscount = parseInt(context.selectedPackage.discountAmount);

  let inclusions = context.selectedPackage.dealType !== "Standalone Fibre Deals" ? context.selectedContractTerm?.inclusions : null;

  if (context.additionalVas) {
    context.additionalVas.map(item => {
      if (parseInt(item?.contractTerm) == parseInt(context?.selectedContractTerm?.duration) || item.category == "contractCover")
        monthlyTotal += parseFloat(item?.price?.replace("R", ""));
      else
        onceOffTotal += parseFloat(item?.price?.replace("R", ""));
    })
    monthlyTotal += parseFloat(context.selectedPackage?.productPrice.value);
  }
  else
    monthlyTotal = context.selectedPackage?.productPrice.value;

  monthlyTotal = parseFloat(monthlyTotal).toFixed(2);
  onceOffTotal = parseFloat(onceOffTotal).toFixed(2);


  function getDiscountString() {
    let discount = parseFloat(context.selectedPackage.productPrice.value) - parseFloat(context.selectedPackage?.discountAmount);
    let price = discount === 0 ? "FREE" : `Only pay R${discount} for the first`;
    return (`${price} ${context?.selectedPackage?.discountTerm}`)
  }

  return (

    <WhiteTile
      className="sales-review-order__summary-mobile"
      onTouchStart={touchStartHandler}
      onTouchMove={onTouchMoveHandler}
      automationid="SalesLeads_Div_SummaryMob_1"
    >
      <div
        className="sales-review-order__expansion-dash-mobile"
        onClick={expansionClickHandler}
        automationid="SalesLeads_Div_SummaryMob_2"
      ></div>
      <div
        className={`sales-review-order__expandar ${!expanded && "sales-review-order__expandar-hidden"
          }`}
        automationid="SalesLeads_Div_SummaryMob_3"
      >

        <Subtitle
          style={{ marginTop: 0, fontWeight: "bold" }}
          automationid="SalesLeads_H4_SummaryMob_1"
        >
          Order summary
        </Subtitle>
        <br />
        <SummaryRow
          title="Fibre"
          value={
            `R${context.selectedPackage.productPrice.value} ${parseInt(context.selectedContractTerm) ? "x " + parseInt(context.selectedContractTerm) : "PM"}`
          }
          onDiscount={onDiscount}
        />

        {
          selectedAdditionalServices.length > 0 ?
            <SummaryRow
              title={getDiscountString()}
              onDiscount={onDiscount}
              onDiscountColor={onDiscount}
            />
          :
            null
        }

        { context.additionalVas
            ? context.additionalVas.map((item, index) => (
              <SummaryRow
                key={index}
                title={item?.displayName}
                value={
                  `${item?.price} ${parseInt(item?.contractTerm) || item.category == "contractCover" ? "PM" : ""}`
                }
              />
            ))
            : null
        }

      </div>

      {
        (selectedAdditionalServices.length > 0 || context.selectedPackageType == "Vodacom One Deals" || inclusions) && (
          <div
            className={`sales-review-order__expandar ${!expanded && "sales-review-order__expandar-hidden"
              }`}
            automationid="SalesLeads_Div_SummaryMob_4"
          >
            <HorizontalLine spacing="0.75rem" />
            <SummaryRow
              title="Extras"
              value={
                context.selectedPackageType == "Vodacom One Deals" ?
                  "Device included"
                  :
                  inclusions ?
                    inclusions[0]
                    :
                    selectedAdditionalServices[0]?.acronym || selectedAdditionalServices[0]?.serviceName
              }
            />
            {
              context.selectedPackageType == "Vodacom One Deals" ?
                <Text
                  key="Device included"
                  style={{ "text-align": "right" }}
                  fontWeight="bold"
                  color="black"
                  automationid={`SalesLeads_P_SummaryWeb_deviceIncluded`}
                >
                  {selectedAdditionalServices[0]?.acronym || selectedAdditionalServices[0]?.serviceName}
                </Text>
                :
                null
            }
            {selectedAdditionalServices?.length > 1 && selectedAdditionalServices?.slice(1, selectedAdditionalServices?.length).map((additionalService) => (
              <Text
                key={additionalService.serviceKey}
                style={{ "text-align": "right" }}
                fontWeight="bold"
                color="black"
                automationid="SalesLeads_P_SummaryMob_2"
              >
                {additionalService.acronym}
              </Text>
            ))}
            {inclusions?.length > 1 && inclusions?.slice(1, inclusions?.length).map((inclusion, index) => (
              <Text
                key={inclusion}
                style={{ "text-align": "right" }}
                fontWeight="bold"
                color="black"
                automationid={`SalesLeads_P_SummaryWeb_${index}`}
              >
                {inclusion}
              </Text>
            ))}
          </div>
        )}

      <HorizontalLine spacing="0.75rem" />

      <SummaryRow
        boldTitle={true}
        title="Monthly total"
        value={
          `R${monthlyTotal} ${parseInt(context.selectedContractTerm) ? "x " + parseInt(context.selectedContractTerm) : "PM"}`
        }
      />

      {
        onceOffTotal > 0 ?
          <SummaryRow
            boldTitle={true}
            title="Once-off"
            value={"R" + onceOffTotal}
          />
          :
          null
      }

      {expanded && onDiscount ? '' : <br />}
      {
        onDiscount &&
        <div
          className={`sales-review-order__expandar ${!expanded && "sales-review-order__expandar-hidden"
            }`}
          automationid="SalesLeads_Div_SummaryMob_5">
          <HorizontalLine spacing="0.75rem" />

          {
            selectedAdditionalServices.length === 0 ?
              <SummaryRow
                title={getDiscountString()}
                onDiscount={onDiscount}
                onDiscountColor={onDiscount}
              />
            :
              null
          }

          {
            totalDiscount > 0 ?
              <SummaryRow
                boldTitle={true}
                title="Total saved"
                value={"R" + totalDiscount}
              />
              :
              null
          }

          <br />
        </div>
      }

      <GreenButton
        className="sales-review-order__submit-button-mobile"
        disabled={!props.isEnabled}
        onClick={submitClickHandler}
        borderRadius={'20px'}
        automationid="SalesLeads_Button_SummaryMob_1"
      >
        <ProtectionLock />
        <span automationid="SalesLeads_Span_SummaryMob_1">
          {props.submitTitle || "Continue"}
        </span>
      </GreenButton>

      {
        props.page ?
          <div className="summary-call-me-back-wrapper">
            <CallMeBackBtn page={props.page} />
          </div>
          :
          null
      }

    </WhiteTile>
  );
};

OrderSummaryMobile.propTypes = {
  isEnabled: PropTypes.bool,
  nextCallBack: PropTypes.func,
  page: PropTypes.string,
  submitRoute: PropTypes.string,
  submitTitle: PropTypes.string,
};

export default withRouter(OrderSummaryMobile);